import { ElasticSearchResponse, FurnitureImageName, NicheShelfDocument } from '@shared/services/elastic-search/models';

export const furnituresImageNameSerializer = (
  nicheShelves: ElasticSearchResponse<NicheShelfDocument>
): FurnitureImageName[] =>
  nicheShelves.hits.hits.map((nicheShelf) => {
    const source = nicheShelf._source;
    return {
      title: source.title?.[0] ?? '',
      image: source.field_images?.[0] ?? undefined!,
    };
  });
